/* i18n setup for SouthTrip — supports en / hi / ml / ta / ar (RTL) */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import ml from "./locales/ml.json";
import ta from "./locales/ta.json";
import ar from "./locales/ar.json";

export const SUPPORTED_LANGS = [
    { code: "en", label: "English", flag: "🇬🇧", dir: "ltr" },
    { code: "hi", label: "हिन्दी", flag: "🇮🇳", dir: "ltr" },
    { code: "ml", label: "മലയാളം", flag: "🇮🇳", dir: "ltr" },
    { code: "ta", label: "தமிழ்", flag: "🇮🇳", dir: "ltr" },
    { code: "ar", label: "العربية", flag: "🇸🇦", dir: "rtl" },
];

export const RTL_LANGS = ["ar"];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            hi: { translation: hi },
            ml: { translation: ml },
            ta: { translation: ta },
            ar: { translation: ar },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "hi", "ml", "ta", "ar"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "southtrip_lang",
        },
    });

/* Apply <html lang> + dir attribute on every change */
const applyDir = (lng) => {
    const dir = RTL_LANGS.includes(lng) ? "rtl" : "ltr";
    document.documentElement.setAttribute("lang", lng);
    document.documentElement.setAttribute("dir", dir);
};
applyDir(i18n.language || "en");
i18n.on("languageChanged", applyDir);

export default i18n;
